export default __webpack_public_path__ + "static/media/wuyeFive.cb651ffb.png";